<template>
  <div class="modal fade" id="modal-fin-info">
    <div class="modal-dialog modal-dialog-l">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title">Управление финансовой информацией</h4>
        </div>
        <div class="modal-body">
          <div v-if="currentCamp != null && currentFinInfo != null" class="row">
            <div class="box-body">
              <div class="form-group">
                <label for="name">Валюта Лагеря</label>
                <select name="currency" class="form-control" v-model="currentFinInfo.currency">
                  <option value="RUB">RUB</option>
                  <option value="EUR">EUR</option>
                  <option value="USD">USD</option>
                  <option value="GBP">GBP</option>
                </select>
              </div>
              <div class="form-group">
                <label for="name">Комиссия на среднесрочные программы</label>
                <input v-model="currentFinInfo.mediumTermComission" type="text" class="form-control" id="name">
              </div>
              <div class="form-group">
                <label for="name">Комиссия на долгосрочные программы</label>
                <input v-model="currentFinInfo.longTermComission" type="text" class="form-control" id="phone">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" data-dismiss="modal">{{$t('button.close')}}</button>
          <button type="button" v-on:click="saveFinInfo" class="btn btn-primary">{{$t('button.save-changes')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CampFinInfo',
  props: {
    currentCamp: Object,
    currentFinInfo: Object
  },
  updated () {

  },
  created () {

  },
  methods: {
    saveFinInfo: function () {
      var self = this;

      axios.get(
        window.rootRoute + '/api/camps/' + self.currentCamp.id + '/finincialInformation')
        .then(function (response) {
          console.log(response.data);

          if (response.data === '') {
            axios.post(
              window.rootRoute + '/api/camps/' + self.currentCamp.id + '/finincialInformation',
              {defaultCurrency: self.currentFinInfo.currency})
              .then(function () {
                var saved = {
                  campComission: {
                    mediumTermComission: {
                      value: self.currentFinInfo.mediumTermComission,
                      currency: self.currentFinInfo.currency
                    },
                    longTermComission: {
                      value: self.currentFinInfo.longTermComission,
                      currency: self.currentFinInfo.currency
                    },
                    defaultCurrency: self.currentFinInfo.currency
                  }
                };

                axios.put(
                  window.rootRoute + '/api/camps/' + self.currentCamp.id + '/finincialInformation',
                  {finInfo: saved})
                  .then(function (resp) {
                    console.log(resp.data);
                    self.$root.$emit('alert', 'success', 'alert.success');
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              })
              .catch(function (error) {
                console.log(error);
                self.$root.$emit('alert', 'error', 'alert.error');
              });
          } else {
            var saved = {
              campComission: {
                mediumTermComission: {
                  value: self.currentFinInfo.mediumTermComission,
                  currency: self.currentFinInfo.currency
                },
                longTermComission: {
                  value: self.currentFinInfo.longTermComission,
                  currency: self.currentFinInfo.currency
                }
              },
              defaultCurrency: self.currentFinInfo.currency
            };

            axios.put(
              window.rootRoute + '/api/camps/' + self.currentCamp.id + '/finincialInformation',
              {finInfo: saved})
              .then(function (resp) {
                console.log(resp.data);
                self.$root.$emit('alert', 'success', 'alert.success');
              })
              .catch(function (error) {
                console.log(error);
                self.$root.$emit('alert', 'error', 'alert.error');
              });
          }
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    }
  }
};
</script>

<style scoped>

</style>
